module.exports = __webpack_public_path__ + "media/images/sp/plans/search_form/checkbox_disabled-fe3c5aa2d8b325fd1854075389f4f089.svg";